// Updated Chat.jsx with ActiveAI click support
import { useState } from "react";
import { SummaryCardGrid, Loader, TabButtonGroup } from "../components/shared";
import { chatItems2, generateCardData, buttonLabels } from "../utils/data";
import CurrentChat from "../components/chatComp/CurrentChat";
import ActiveAI from "../components/chatComp/ActiveAI";
import { useMediaQuery, useAgentData, useChatPageData } from "../utils/hooks";
import { useOutletContext } from "react-router-dom";
import AIsuggestions from "../components/Dashboard/AIsuggestions";

const Chat = () => {
  const { dashboardSummary, loading: summaryLoading } = useAgentData();
  const { activeChatsList = [], loading: chatLoading } = useChatPageData();

  const [selectedChatId, setSelectedChatId] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(2);

  const { toggleSidebar } = useOutletContext();
  const isMdUp = useMediaQuery("(min-width: 768px)");

  if (summaryLoading || chatLoading) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }

  const cardData = dashboardSummary ? generateCardData(dashboardSummary) : [];
  const chatCardData = chatItems2(activeChatsList);

  const currentChatData = activeChatsList.find(
    (chat) => chat.id === selectedChatId
  );

  return (
    <div className="flex flex-row w-full min-h-[calc(100vh-100px)]">
      <div className="flex flex-col w-full h-auto gap-2 lg:gap-2">
        <div className="w-full h-auto border-b border-[#0000002B] flex justify-between items-center pb-2">
          <h1 className="text-[13px] font-semibold leading-[100%] text-black font-inter">
            Chat Box
          </h1>
          <div className="flex flex-row items-center gap-2 md:hidden">
            <button
              onClick={toggleSidebar}
              className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
            >
              Menu
            </button>
          </div>
        </div>
        <TabButtonGroup
          buttonLabels={buttonLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <SummaryCardGrid data={cardData} />

        {!selectedChatId ? (
          <div className="flex-1 w-full h-full pr-2">
            <div className="w-full flex-1 h-full shadow-[4px_4px_47.1px_0px_#00000040] rounded-[10px] px-1 pt-1 overflow-hidden">
              <div className="flex flex-col h-full gap-0 pr-1 mt-2 overflow-y-auto">
                {chatCardData.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-row items-center w-full gap-1 px-3 py-1 cursor-pointer"
                    onClick={() => setSelectedChatId(item.id)}
                  >
                    <div className="relative">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-[45px] h-[45px] rounded-full object-contain"
                      />
                      <div
                        className={`w-[10px] h-[10px] border-2 border-white rounded-full absolute bottom-0 right-0 ${
                          item.status === "available"
                            ? "bg-[#4DFF00]"
                            : "bg-[#E4E000]"
                        }`}
                      />
                    </div>
                    <div className="flex flex-col w-full pt-2 pl-4">
                      <div className="flex items-center justify-between w-full">
                        <span className="text-[12px] font-semibold font-inter text-black">
                          {item.name}
                        </span>
                        <span className="text-[11px] font-medium font-inter text-[#00000073] px-2 py-0.5 rounded">
                          {item.time}
                        </span>
                      </div>
                      <div className="text-[11px] py-1 font-inter text-[#00000073] text-opacity-80">
                        {item.message}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex-1 mt-4">
            <CurrentChat
              chat={currentChatData}
              onBack={() => setSelectedChatId(null)}
              onSelectChat={setSelectedChatId} // ✅ pass the function
              activeChatsList={activeChatsList} // ✅ pass the list too
            />
          </div>
        )}
      </div>

      {isMdUp && (
        <div className="border-[#0000002B] border-l w-[20%] min-w-[220px] max-w-[280px] flex flex-col h-[calc(100vh-100px)]">
          <div className="flex-1 flex flex-col min-h-0">
            {selectedChatId ? (
              <ActiveAI onSelectChat={(id) => setSelectedChatId(id)} />
            ) : (
              <AIsuggestions chat={currentChatData} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Chat;
